import { CONSTANT_URL } from './../../../constant/constant-url';
import { LogService } from './../../share/log/log.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticateService } from '../../share/authenticate/authenticate.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../share/validation/validation.service';
import { MsgService } from '../../share/msg/msg.service';
import { UtilService } from '../../share/util/util.service';
import { VERSION } from '../../../environments/version';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  VERSION = VERSION;
  SKS_WEBSITE = CONSTANT_URL.SKS_WEBSITE;
  public SKS_TERMS_OF_SERVICE = CONSTANT_URL.SKS_TERMS_OF_SERVICE;
  // ラベル名
  labelPageTitle = 'サインイン';
  labelSigninId = 'ユーザー名';
  labelPassword = 'パスワード';
  labelNewPass = '新しいパスワード';
  labelNewPassConfirm = '新しいパスワードの確認';
  labelCode = '検証コード';
  // 各フォーム毎にプロパティを設定。
  // Validationを"Validators.XXX"で指定する。(検証についてはモデル駆動型フォームを採用)
  signinId = new FormControl('', [
    Validators.required,
    Validators.minLength(6),
    Validators.maxLength(23),
  ]);
  password = new FormControl('', [
    Validators.required
  ]);
  newPass = new FormControl('', [
    Validators.required
  ]);
  newPassConfirm = new FormControl('', [
    Validators.required
  ]);
  signinIdForgot = new FormControl('', [
    Validators.required,
    Validators.minLength(6),
    Validators.maxLength(23),
  ]);
  code = new FormControl('', [
    Validators.required
  ]);
  /** input type */
  inputPasswordType = 'password';
  newPassType = 'password';
  newPassConfirmType = 'password';

  autoInput = {
    username: null,
    password: null,
  };

  loadImgClass = 'load-img-sm';

  /** フォーカス対象をテンプレートのidで指定。配列順にフォーカス移動する。）*/
  focusSeqNoneMode = [
    'signinId',
    'password',
  ];
  focusSeqFirstPassSettingMode = [
    'newPass',
    'newPassConfirm',
  ];
  focusSeqForgotPassMode = [
    'signinId',
  ];
  focusSeqInputCodeMode = [
    'code',
    'signinId',
    'newPass',
    'newPassConfirm'
  ];

  constructor(
    public authServ: AuthenticateService,
    private logServ: LogService,
    private builder: FormBuilder,
    public validationServ: ValidationService,
    public utilServ: UtilService,
    private route: ActivatedRoute,
    public msgServ: MsgService,
  ) { }

  ngOnInit() {
    this.utilServ.uUI.setTitleBar(this.labelPageTitle);

    // クエリパラメータ取得
    this.route.queryParams.subscribe(
      params => {
        this.autoInput.username = params['u'];
        this.autoInput.password = params['c'];
        if (this.autoInput.username) {
          this.signinId.setValue(this.autoInput.username);
        }
        if (this.autoInput.password) {
          this.password.setValue(this.autoInput.password);
        }
        if (this.signinId.value && this.password.value) {
          this.clickSignin();
        }
      }
    );
  }

  public getCurrentSeq(): string[] {
    let focusArray: string[];
    if (this.authServ.mode.firstPassSettingMode) {
      focusArray = this.focusSeqFirstPassSettingMode;
    } else if (this.authServ.mode.inputCodeMode) {
      focusArray = this.focusSeqInputCodeMode;
    } else if (this.authServ.mode.forgotPassMode) {
      focusArray = this.focusSeqForgotPassMode;
    } else {
      focusArray = this.focusSeqNoneMode;
    }
    return focusArray;
  }

  public async clickSignin() {
    if (this.validaitonBeforeSignin()) {
      this.logServ.sendSigninLogAsync('ng', this.signinId.value, this.password.value);
      return;
    }
    this.authServ.signIn(this.signinId.value, this.password.value);
  }

  /** フォーム値の検証。(サインイン時)
    * @return {boolean} return = true ならば、データ更新しない
  */
  private validaitonBeforeSignin(): boolean {
    this.validationServ.validationInvalid = false;

    this.signinId.markAsDirty();
    this.validationServ.formValidation(this.signinId, this.labelSigninId);

    this.password.markAsDirty();
    this.validationServ.formValidation(this.password, this.labelPassword);
    this.validationServ.cognitoPassValidation(this.password);

    return this.validationServ.validationInvalid;
  }
}
